<div class="custom-spinner">
  <mat-progress-spinner
    mode="indeterminate"
    diameter="{{diameter}}"
    strokeWidth="{{strokeWidth}}"
  ></mat-progress-spinner>
</div>
